// extracted by mini-css-extract-plugin
module.exports = {"container":"eventPageLayout_container__bBvb-"};